import { jsonToFormData } from 'util/jsonToFormData';
import { selectApiData, selectApiNoContent } from 'util/selector/apiSelector';
import { selectResponseData } from 'util/selector/axiosSelector';

import { ApiMessage } from 'api/const';
import { WithData } from 'api/interfaces';
import { AxiosInstance } from 'axios';
import { PaginationDto, PaginationModel } from 'model/Pagination.dto';

import { ClientDto, ClientModel, mapClientDtoToModel, mapClientModelToDto } from './dto/Client.dto';

export namespace ClientApi {
  export type PaginatedEntry = PaginationDto & {
    _embedded: {
      items: ClientDto;
    };
  };
}

export class ClientApi {
  constructor(private client: AxiosInstance) {}

  get(query: string): Promise<{ list: ClientModel[]; pagination: PaginationModel }> {
    return this.client
      .get(`/api/v1/company/clients${query}`)
      .then((response) => selectResponseData(response) || [])
      .then((entry) => ({
        list: entry._embedded.items.map(mapClientDtoToModel),
        pagination: entry,
      }));
  }

  create(client: ClientModel, logo?: File): Promise<ClientModel> {
    const clientDto = mapClientModelToDto(client);

    const newClient = { ...clientDto, logoFile: logo };
    return this.client
      .post<WithData<ClientDto>>(`/api/v1/company`, jsonToFormData(newClient))
      .then(selectApiData)
      .then((data) => mapClientDtoToModel(data));
  }

  delete(clientId: number): Promise<void> {
    return this.client
      .delete<ApiMessage.Deleted>(`/api/v1/company/${clientId}`)
      .then(selectApiNoContent);
  }

  changePlan(clientId: number, plan: number): Promise<ClientDto> {
    return this.client
      .post<WithData<ClientDto>>(`/api/v1/company/${clientId}/plan`, { plan: plan })
      .then(selectApiData);
  }
}
